<div class="content-full message release-view d-flex flex-column h-100">
    <kno2-message-action-bar
        class="mt-n3"
        [message]="message"
        [attachments]="attachments"
        [patientIntegrationMeta]="patientIntegrationMeta()"
        [deliverySummaryEnableDownload]="deliverySummaryEnableDownload()" />

    <div class="row">
        <div class="col-sm-9 col-lg-8 col-xl-8 col-no-padding d-flex flex-column">
            <div class="header pt-2 border-bottom-0">
                @if (error()?.title) {
                    <kno2-notification-alert
                        type="danger"
                        [title]="error().title"
                        [messages]="error().messages"
                        (dismiss)="clearError()" />
                }
                @if (serverError()) {
                    <div class="mb-2">
                        <kno2-notification-alert
                            type="danger"
                            [title]="serverError()" />
                    </div>
                }
                <kno2-release-address-panel />
            </div>

            <div
                class="doc-viewer"
                id="doc-viewer">
                <kno2-pdf-viewer-container
                    [attachment]="selectedAttachment()"
                    [options]="viewerOptions()" />

                @let patientForm = form.get("patient");
                <div class="release-body-message-summary">
                    <h2>Message Body</h2>
                    <ul class="patient-details-list">
                        <li>
                            Patient ID:
                            <span class="message-body-information">{{ patientForm.get("patientId").value }}</span>
                        </li>
                        <li>
                            Patient Name:
                            <span class="message-body-information">
                                {{ patientForm.get("firstName").value }} {{ patientForm.get("middleName").value }} {{ patientForm.get("lastName").value }}
                            </span>
                        </li>
                        <li>
                            Gender:
                            <span class="message-body-information">{{ patientForm.get("gender").value }}</span>
                        </li>
                        <li>
                            DOB:
                            <span class="message-body-information">{{ patientForm.get("birthDate").value | date: "MM/dd/yyyy" }}</span>
                        </li>
                        <li>
                            Address:
                            <span class="message-body-information">{{ patientForm.get("streetAddress1").value }}</span>
                            <span class="message-body-information ms-1">{{ patientForm.get("streetAddress2").value }}</span>
                            <span class="message-body-information ms-1">{{ patientForm.get("city").value }}</span>
                            <span class="message-body-information">{{ patientForm.get("state").value ? `, ${patientForm.get("state").value}` : "" }}</span>
                            <span class="message-body-information ms-1">{{ patientForm.get("postalCode").value }}</span>
                        </li>
                        <li>
                            Phone:
                            <span class="message-body-information">{{ patientForm.get("telephone").value }}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="col-sm-3 col-lg-4 col-xl-4 auto-fill intake-right-border col-no-gutters d-flex flex-column">
            <kno2-message-patient-details
                [integrationName]="capabilities()?.displayName"
                [(patientIntegrationMeta)]="patientIntegrationMeta"
                [capabilities]="capabilities()?.capabilities"
                [hasExternalLogin]="capabilities()?.externalLogin"
                [showPatientLookup]="true"
                [showVisitLookup]="false"
                [showVisitDetails]="false" />
            <div class="flex-grow-1 mb-5">
                <kno2-message-patient-attachments
                    (onPatientMeta)="extractPatientMeta($event)"
                    [(attachments)]="attachments"
                    [(selectedAttachment)]="selectedAttachment"
                    [patientIntegrationMeta]="patientIntegrationMeta()"
                    [integrationName]="capabilities()?.displayName"
                    [capabilities]="capabilities()?.capabilities"
                    [hasExternalLogin]="capabilities()?.externalLogin"
                    [documentTypes]="documentTypes()"
                    [showAddAttachment]="true"
                    [showRenameAttachment]="true"
                    [showDeleteAttachment]="true"
                    [showOrderLookup]="false" />
            </div>
        </div>
    </div>
</div>
